const EXIT_CTA_LABEL = {
  BACK_TO_LISTING: 'Back to listing',
  EXIT: 'Exit',
  SAVE_AND_EXIT: 'Save & exit',
};

export { EXIT_CTA_LABEL };
